import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServiceOperation } from '../../../models';

export interface IServiceOperationMonitor {
  isAddNewServiceOperation: boolean,
  isEditServiceOperation: boolean,
  editServiceOperationIndex: undefined | number,
  editedServiceOperation: undefined | IServiceOperation,
  isDeleteServiceOperationDetailsButtonClicked: boolean,
  isBackButtonWasPressedOnException: boolean
  deleteIndex: undefined | number,
  isEditService: boolean,
  isServiceNameError: boolean,
  isSchemaNameFocus: boolean,
  showServiceExistWarning: boolean
}

interface IDeleteServiceOperation {
  index: number | undefined,
  isDeleteServiceOperation: boolean
}

interface IEditServiceOperation {
  index: number | undefined,
  isEditServiceOperation: boolean
}

/**
 * Initial edit ServiceOperation state in store
 */
const initialState: IServiceOperationMonitor = {
  isAddNewServiceOperation: false,
  isEditServiceOperation: false,
  editServiceOperationIndex: undefined,
  editedServiceOperation: undefined,
  isDeleteServiceOperationDetailsButtonClicked: false,
  isBackButtonWasPressedOnException: false,
  deleteIndex: undefined,
  isEditService: false,
  isServiceNameError: false,
  isSchemaNameFocus: false,
  showServiceExistWarning: false
};

/**
 * get service operation Slice to get service operation actions
 */
export const serviceOperationMonitorSlice = createSlice({
  name: 'serviceOperationMonitor',
  initialState,
  reducers: {
    setIsEditService: (state, action: PayloadAction<boolean>) => {
      state.isEditService = action.payload;
    },
    setIsAddNewServiceOperation: (state, action: PayloadAction<boolean>) => {
      state.isAddNewServiceOperation = action.payload;
    },

    setIsEditServiceOperation: (state, action: PayloadAction<IEditServiceOperation>) => {
      state.isEditServiceOperation = action.payload.isEditServiceOperation;
      state.editServiceOperationIndex = action.payload.index;
    },

    setIsDeleteServiceOperationDetailsButtonClicked: (state, action: PayloadAction<IDeleteServiceOperation>) => {
      state.isDeleteServiceOperationDetailsButtonClicked = action.payload.isDeleteServiceOperation;
      state.deleteIndex = action.payload.index;
    },

    setIsBackButtonWasPressedOnException: (state, action: PayloadAction<boolean>) => {
      state.isBackButtonWasPressedOnException = action.payload;
    },
    setIsServiceNameError: (state, action: PayloadAction<boolean>) => {
      state.isServiceNameError = action.payload;
    },

    setShowServiceExistWarning: (state, action: PayloadAction<boolean>) => {
      state.showServiceExistWarning = action.payload;
    },

    clearServiceOperationMonitor: (state) => {
      state.isAddNewServiceOperation = false;
      state.isEditServiceOperation = false;
      state.editServiceOperationIndex = undefined;
      state.isDeleteServiceOperationDetailsButtonClicked = false;
      state.deleteIndex = undefined;
      state.isEditService = false;
      state.isBackButtonWasPressedOnException = false;
      state.isSchemaNameFocus = false;
      state.isServiceNameError = false;
      state.showServiceExistWarning = false;
    }
  }
});

export const {
  setIsAddNewServiceOperation,
  setIsEditServiceOperation,
  setIsDeleteServiceOperationDetailsButtonClicked,
  clearServiceOperationMonitor,
  setIsBackButtonWasPressedOnException,
  setIsEditService,
  setIsServiceNameError,
  setShowServiceExistWarning } = serviceOperationMonitorSlice.actions;
export default serviceOperationMonitorSlice.reducer;
